module.exports = __webpack_public_path__ + "static/media/img-school-wish-list-video.809a2dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/img-school-wish-list-video.png
// module id = 438
// module chunks = 0